import { render, staticRenderFns } from "./TeacherCourseLayout.vue?vue&type=template&id=8277264a&scoped=true&"
import script from "./TeacherCourseLayout.vue?vue&type=script&lang=js&"
export * from "./TeacherCourseLayout.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCourseLayout.vue?vue&type=style&index=0&id=8277264a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8277264a",
  null
  
)

export default component.exports